import React from 'react';

import Thumb from '../img/blogs/javascript-es6.jpg';

const MostJavaScriptNewFeatureInES6 = {
    id: 7, permalink: "most-javascript-new-feature-in-es6", thumb: Thumb, postBy: "Wasek Bellah", postDate: "May 01, 2020", categories: "JavaScript, ES6", title: "Most JavaScript New Feature In ES6", shortDesc: "ECMAScript 6 is also known as ES6 and ECMAScript 2015. Some people call it JavaScript 6. This chapter will introduce some of the new features in ES6.", fullDesc: <>
        <h2>Var Declarations and Hoisting</h2>
        <p>When declaring a <strong>variable</strong> using the <code>var</code> keyword it <strong>hoisted</strong> at the top. If declared into a <strong>function hoisted</strong> at that <strong>function</strong> and if declared in <strong>global scop</strong>e than it <strong>hoisted</strong> at <strong>window object</strong>.</p>

        <pre className="code">
            <h4>&#47;&#47; ES5</h4>
            console.log(age) <br />
            var age = 21;
        </pre>
        <p><strong>Expected output:</strong> <code className="output">undefined</code></p>

        <p><strong>Value exists</strong> before declaring a <strong>variable</strong> with <code>var</code> keyword with a value of <code>undefined</code></p>


        <h2>Let Declarations</h2>
        <p>The <code>let</code> declaration syntax is the same as the syntax for <code>var</code>. We can basically replace <code>var</code> with <code>let</code> to declare a <strong>variable</strong>. But <code>var</code> is <strong>function scope variable</strong> and <code>let</code> is <strong>block scope variable</strong>. Since <code>let</code> declarations are not <strong>hoisted</strong> to the top of the enclosing block.</p>

        <pre className="code">
            &#123; <br />
                &nbsp; let name = "Wasek Bellah"; <br />
                &nbsp; console.log(name); <br />
            &#125;
        </pre>
        <p><strong>Expected output:</strong> <code className="output">Wasek Bellah</code></p>

        <pre className="code">
            &#123; <br />
                &nbsp; let name = "Wasek Bellah"; <br />
            &#125; <br />
            console.log(name);
        </pre>
        <p><strong>Expected output:</strong> <code className="output">ReferenceError: name is not defined</code></p>
        <p>Because, <code>let</code> is <strong>block scope variable</strong>. We can't access it from outside of <code>&#123; &#125;</code>.</p>


        <h2>Const Declarations</h2>
        <p><strong>Variables</strong> declared using <code>const</code> are considered <strong>constants</strong>, meaning their values cannot be changed once set. For this reason, every <code>const</code> <strong>variable</strong> must be initialized on the declaration. And <code>const</code> is also <strong>block scope variable</strong> like <code>let</code>.</p>

        <pre className="code">
            const name = "Wasek Bellah"; <br />
            name = "John"; <br />
            console.log(name);
        </pre>
        <p><strong>Expected output:</strong> <code className="output">TypeError: Assignment to constant variable.</code></p>
        <p>Because, <code>const</code> values cannot be changed once set.</p>

        <h2>Global Block Bindings</h2>
        <p><code>let</code> and <code>const</code> <strong>global scope behavior</strong> are different from <code>var</code> <strong>global scope behavior</strong>.</p>

        <p>When <code>var</code> is used in the <strong>global scope</strong>, it creates a new <strong>global variable</strong>, which is a property of the <strong>window object</strong>. That means you can overwrite existing <strong>global</strong> using <code>var</code>.</p>

        <pre className="code">
            <h4>&#47;&#47; ES5</h4>
            <h4>In a Browser console</h4>
            var age = 21; <br />
            window.age; <br />
            var RegExp = "Hello World!"; <br />
            window.RegExp; <br />
        </pre>
        <p><strong>Expected output:</strong> <code className="output">21</code> and <code className="output">Hello World!</code></p>

        <pre className="code">
            <h4>&#47;&#47; ES5</h4>
            <h4>In a Browser console</h4>
            var RegExp = "Hello World!"; <br />
            window.RegExp === RegExp;
        </pre>
        <p><strong>Expected output:</strong> <code className="output">true</code></p>

        <p>Above examples, the <code>var RegExp</code> overwrite the <code>window.RegExp</code>, it is not safe to overwrite by a <code>var</code> declaration.</p>

        <p>But, when <code>let or const</code> is used in the <strong>global scope</strong>, a new binding is created in the <strong>global scope</strong>, which is not added a property to the <strong>global object</strong>. That means you cannot overwrite existing <strong>global</strong> using <code>let or const</code>.</p>

        <pre className="code">
            <h4>&#47;&#47; ES6</h4>
            <h4>In a Browser console</h4>
            let RegExp = "Hello World!"; <br />
            RegExp; <br />
            window.RegExp === RegExp;
        </pre>
        <p><strong>Expected output:</strong> <code className="output">Hello World!</code> and <code className="output">false</code></p>


        <h2>Arrow Functions</h2>
        <p>One of the most interesting new parts of the <strong>ES6</strong> is the <strong>arrow</strong> <code>=></code> <strong>function</strong>.</p>

        <pre className="code">
            <h4>&#47;&#47; ES5</h4>
            function add(a, b) &#123; <br />
                &nbsp; return a + b; <br />
            &#125; <br />
            console.log(add(10, 15));
        </pre>
        <p><strong>Expected output:</strong> <code className="output">25</code></p>

        <pre className="code">
            <h4>&#47;&#47; ES6</h4>
            const add = (a, b) => a + b; <br />
            console.log(add(10, 15));
        </pre>
        <p><strong>Expected output:</strong> <code className="output">25</code></p>


        <h2>Functions with Default Parameter</h2>
        <p><strong>JavaScript Functions</strong> are allowed to the passed of any <strong>parameter</strong> regardless of the number of declared <strong>parameters</strong>. This allows you to define <strong>functions</strong> that can handle different <strong>parameters</strong>, often by default, if <strong>parameters</strong> are not provided.</p>

        <pre className="code">
            <h4>&#47;&#47; ES5</h4>
            function add(a, b) &#123; <br />
                &nbsp; a = a || 5; <br />
                &nbsp; b = b || 6; <br />
                &nbsp; return a + b; <br />
            &#125; <br />
            console.log(add());
        </pre>
        <p><strong>Expected output:</strong> <code className="output">11</code></p>

        <p>The <strong>logical OR operator</strong> <code>||</code> always returns the <strong>second operand</strong> after the first has been <strong>falsy</strong>. Here when used <strong>function</strong> then no <strong>parameters</strong> have been given that's why the value of the <strong>parameters</strong> are <code>undefined</code>.</p>

        <p><em>In <strong>ES6</strong> there is no need to use <strong>logical OR operator</strong> <code>||</code> to set default parameters</em>:</p>
        <pre className="code">
            <h4>&#47;&#47; ES6</h4>
            const add = (a = 5, b = 6) => a + b; <br />
            console.log(add());
        </pre>
        <p><strong>Expected output:</strong> <code className="output">11</code></p>


        <h2>The Spread Operator</h2>
        <p>The <code>...</code> <strong>spread operator</strong> allows repeaters to extend where 0+ <strong>arguments</strong> are expected. It is mostly used in a <strong>variable array</strong> where more than 1 values are expected. This allows us to get a list of <strong>parameters</strong> from the array.</p>

        <pre className="code">
            <h4>&#47;&#47; ES6</h4>
            const ages = [45, 12, 24, 43, 26]; <br />
            console.log(ages); <br />
            console.log(...ages);
        </pre>
        <p><strong>Expected output:</strong> <code className="output">[ 45, 12, 24, 43, 26 ]</code> and <code className="output">45 12 24 43 26</code></p>


        <h2>Destructuring</h2>
        <p><strong>Destructuring</strong> is a convenient way of extracting multiple values from data stored in <strong>Objects and Arrays</strong>. It allows you to assign the properties of an <strong>array or object</strong> to <strong>variables</strong> using a syntax that looks similar to <strong>array or object literals</strong>. <strong>ECMAScript 6</strong> simplifies this structure by adding <strong>destructing</strong>, which is the process of breaking down a data structure into <strong>smaller parts</strong>.</p>


        <h2>Object Destructuring</h2>
        <p>The <strong>Object Destructuring</strong> Syntax uses an <strong>object literal</strong> to the left of an assignment activity.</p>

        <pre className="code">
            <h4>&#47;&#47; ES5</h4>
            var person = &#123; name: "Wasek Bellah", age: 21 &#125; <br />
            var name = person.name; <br />
            var age = person.age; <br />
            console.log(name); <br />
            console.log(age);
        </pre>
        <p><strong>Expected output:</strong> <code className="output">Wasek Bellah</code> and <code className="output">21</code></p>

        <p>This code extracts the values of <code>name</code> and <code>age</code> from the options <strong>object</strong> and stores that name in local names with the same name. This code looks simple, imagine if you have a large number of <strong>variables</strong> to determine, you need to assign them one by one.</p>

        <pre className="code">
            <h4>&#47;&#47; ES6</h4>
            const person = &#123; name: "Wasek Bellah", age: 21 &#125; <br />
            const &#123; name, age &#125; = person; <br />
            console.log(name); <br />
            console.log(age);
        </pre>
        <p><strong>Expected output:</strong> <code className="output">Wasek Bellah</code> and <code className="output">21</code></p>

        <p>In this code, the value of <code>person.name</code> is stored in a <strong>variable</strong> called <code>name</code> and the value of <code>person.age</code> is stored in a <strong>variable</strong> called <code>age</code>.</p>


        <h2>Array Destructuring</h2>
        <p><strong>Array destructuring syntax</strong> is very similar to <strong>object destructuring</strong>. It uses <strong>array literal syntax</strong> instead of <strong>object literal syntax</strong>.</p>

        <pre className="code">
            <h4>&#47;&#47; ES5</h4>
            var colors = ["red", "green", "blue"]; <br />
            var red = colors[0]; <br />
            var green = colors[1]; <br />
            var blue = colors[2]; <br />
            console.log(red); <br />
            console.log(green); <br />
            console.log(blue);
        </pre>
        <p><strong>Expected output:</strong> <code className="output">red</code>, <code className="output">green</code> and <code className="output">blue</code></p>

        <pre className="code">
            <h4>&#47;&#47; ES6</h4>
            const colors = ["red", "green", "blue"]; <br />
            const [red, green, blue] = colors; <br />
            console.log(red); <br />
            console.log(green); <br />
            console.log(blue);
        </pre>
        <p><strong>Expected output:</strong> <code className="output">red</code>, <code className="output">green</code> and <code className="output">blue</code></p>

    </>
};
export default MostJavaScriptNewFeatureInES6;